import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = useCallback((packageId, name, price, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.package_id === packageId);
      if (existing) {
        return prev.map((i) => i.package_id === packageId ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, { package_id: packageId, name, price, quantity: qty }];
    });
    setIsOpen(true);
  }, []);

  const updateQuantity = useCallback((packageId, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.package_id !== packageId));
    } else {
      setItems((prev) => prev.map((i) => i.package_id === packageId ? { ...i, quantity: Math.min(qty, 25) } : i));
    }
  }, []);

  const removeItem = useCallback((packageId) => {
    setItems((prev) => prev.filter((i) => i.package_id !== packageId));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);
  const totalPrice = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, isOpen, setIsOpen, addItem, updateQuantity, removeItem, clearCart, totalItems, totalPrice }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
